var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMspIconKsxExInvSyncAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H18V20H15V4Z",
    fill: "#006DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H9V20H6V4Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMspIconKsxExInvSyncAgent);
export default __webpack_public_path__ + "static/media/msp-icon-ksx-ex_inv_sync_agent.323f64ef604c6e422c3f032bd3b59092.svg";
export { ForwardRef as ReactComponent };